/* PureState scroll reveal.
   Loaded WITHOUT defer so the sr-enabled class lands before first paint
   (prevents a visible flash-then-hide). Reveal once, never re-animate. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('sr-enabled');

  var STAGGER_MS = 90;

  function init() {
    document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      group.querySelectorAll('[data-reveal-item]').forEach(function (item, i) {
        item.style.transitionDelay = i * STAGGER_MS + 'ms';
      });
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.hasAttribute('data-reveal-group')) {
            el.querySelectorAll('[data-reveal-item]').forEach(function (item) {
              item.classList.add('sr-in');
            });
          } else {
            el.classList.add('sr-in');
          }
          io.unobserve(el);
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('[data-reveal], [data-reveal-group]').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
